import { useContext } from 'react'
import { LoadingContext } from '@/store/loadingContext'

export const useGobalLoading = () => {
  const context = useContext(LoadingContext)
  if (!context) {
    throw new Error('useDeviceStore must be used within a LoadingContext.Provider')
  }
  return context
}
